export {default as images} from './images';
export const navigationItems =  ['home', 'about', 'work', 'skills', 'contact'];